export function SiteHeader({ testMode = false }: { testMode?: boolean }) {
  return (
    <header className="site-header">
      <a className="wordmark" href="/" aria-label="Don't Press home">
        DON'T <span>PRESS</span>
      </a>
      <nav aria-label="Primary navigation">
        <a href="/history">History</a>
        <a href="/rules">Rules</a>
        <a href="/faq">FAQ</a>
      </nav>
      {testMode ? (
        <a className="test-mode" href="/admin">
          TEST MODE · CONTROLS
        </a>
      ) : null}
    </header>
  );
}
